import Vue from "vue";
import Vuex from "vuex";
import VueAxios from "vue-axios";
import axios from "axios";
import Vehicle from "./modules/vehicle.js";
import Auth from "./modules/auth.js";
import Invoice from "./modules/invoice.js";
import Booking from "./modules/booking.js";
import DelegationOrder from "./modules/delegationOrder.js";
import Delegation from "./modules/delegation.js";
import Dialog from "./modules/dialog.js";
import Ajax from "./modules/ajax.js";
import Location from "./modules/location";
import Visual from "./modules/visual.js";
import Shared from "./modules/shared";
import TravelService from "./modules/travelService";
import Settings from "./modules/settings";
import AdminTravelService from "./modules/adminTravelService";
import createMutationsSharer from "vuex-shared-mutations";

//import createMutationsSharer from 'vuex-shared-mutations'

Vue.use(Vuex);
Vue.use(VueAxios, axios);

const sharedMutations = ["Location/addLocation"];

export default new Vuex.Store({
  modules: {
    Vehicle,
    Auth,
    Invoice,
    Booking,
    DelegationOrder,
    Delegation,
    Dialog,
    Ajax,
    Visual,
    Shared,
    Location,
    TravelService,
    Settings,
    AdminTravelService
  },
  plugins: [
    createMutationsSharer({
      predicate: (mutation /*, state*/) => {
        return mutation.type.startsWith("Shared/") || sharedMutations.includes(mutation.type);
      }
    })
  ]
});
